module.exports = __webpack_public_path__ + "static/media/card_s1.9a5ca3fd.jpg";